import { useEffect, useState } from 'react';

export function useIsDarkTheme() {
  const getCurrentTheme = () =>
    document.documentElement.getAttribute("data-theme") === "dark";

  const [isDark, setIsDark] = useState(getCurrentTheme);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(getCurrentTheme());
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  return isDark;
}